import {
Component,
ElementRef,
Inject,
Input,
OnInit,
ViewChild
} from '@angular/core';

import { RepositoryServiceToken } from '../../services';
import { IRepositoryService } from '../../services/i';

import { CommonModule } from '@angular/common';
import { DocumentViewModel } from 'app/view-models';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.css'],
  imports: [ CommonModule, ],
  standalone: true,
})
export class DownloadComponent implements OnInit {
  @ViewChild('downloadLink') downloadLink: ElementRef;
  @Input() id: number;
  download: DocumentViewModel;
  url: string;

  constructor(
    @Inject(RepositoryServiceToken) private repo: IRepositoryService,
    // @Inject(MapperServiceToken) private mapper: IMapperService,
    // private route: ActivatedRoute,
    // private router: Router
  ) {}

  ngOnInit() {
    this.repo
      .Get(DocumentViewModel, this.id)
      .toPromise()
      .then(doc => {
        this.download = doc;
        const bytes = atob(doc.DocumentFile.ContentBytes);
        const nums = new Array(bytes.length);
        for (let i = 0; i < bytes.length; i++) {
          nums[i] = bytes.charCodeAt(i);
        }
        const byteArray = new Uint8Array(nums);
        const blob = new Blob([byteArray], { type: doc.ContentType });
        // if (window.navigator.hasOwnProperty('msSaveOrOpenBlob')) {
        //   window.navigator.msSaveOrOpenBlob(blob, doc.Filename);
        // } else {
        const url = URL.createObjectURL(blob);
        this.downloadLink.nativeElement.innerText = doc.Filename;
        this.downloadLink.nativeElement.href = url;
        this.downloadLink.nativeElement.download = doc.Filename;
        this.downloadLink.nativeElement.addEventListener(
          'click',
          function (ev: Event) {
            ev.cancelBubble = true;
            ev.stopPropagation();
            return false;
          },
          true
        );
        this.downloadLink.nativeElement.click();
        // }
      });
  }
}
